import axiosService from "./axios-services";

const setAdminAuthorizationToken = (authorization: string | undefined) => {
  if (authorization) {
    axiosService.defaults.headers.common.Authorization = `${authorization}`;
    axiosService.defaults.headers.common["Content-Type"] = 'application/json'
  }
};

export default setAdminAuthorizationToken;
